/** @jsx jsx */
import { Flex, jsx, Heading, Box } from "theme-ui";
import React from "react";
import { DeepExtractTypeSkipArrays } from "ts-deep-extract-types";
import { ContentTimetableFragment } from "../../../../gatsby-graphql";

export type TripProps = { heading: string; dataFile: string };
export const Trip: React.FC<TripProps> = ({ heading, dataFile }) => {
  const parsedData = parseDataFile(dataFile);

  const timeTable = parsedData.map((row, i) => {
    const even = i % 2 === 0;

    const columns = row.map((col, colIndex) => {
      const isFirstColumn = colIndex === 0;
      const bg = even ? "#CCE7F4" : "#B7DDEF";
      const firstColumnStyles = {
        position: "sticky",
        left: 0,
        fontWeight: "bold",
      };

      return (
        <Box
          key={`${heading}-col-${colIndex}`}
          bg={bg}
          px={2}
          as="td"
          sx={isFirstColumn ? { ...firstColumnStyles } : {}}
        >
          {col}
        </Box>
      );
    });
    return (
      <Box key={`${heading}-row-${i}`} as="tr">
        {columns}
      </Box>
    );
  });
  return (
    <Flex pt={4} sx={{ flexDirection: "column" }}>
      <Heading pb={2} as="h2">
        {heading}
      </Heading>
      <Box sx={{ overflowX: "auto" }}>
        <Box as="table" sx={{ whiteSpace: "nowrap" }}>
          <Box as="tbody">{timeTable}</Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default Trip;

type DataFile = DeepExtractTypeSkipArrays<TripProps, ["dataFile"]>;

function parseDataFile(dataFile: string): Array<Array<string>> {
  //get the actual content

  //console.log("dataFie", dataFile);
  //split into rows by CRLF
  const rows = dataFile.split("\r\n");

  //console.log(rows);

  const result: Array<Array<string>> = rows.map((line) => {
    return line.split(",");
  });

  //console.log(result);

  return result;
}
